// https://switcheroo.atlassian.com/ui/gates/1e5123de-54d1-4f51-a02c-5bf53fc51402/key/rovo_chat_non_mau_cta_filter
// TAP trait-backed audience filter: is_rovo_enabled_for_tenant = true AND is_rovo_mau = false
export const ROVO_CHAT_NON_MAU_CTA_FILTER_GATE = 'rovo_chat_non_mau_cta_filter';

// https://switcheroo.atlassian.com/ui/gates/47920126-ac65-430a-97ab-ffe57778f15c/key/rovo_chat_non_mau_jira_confluence_cta_lifecycle
// Lifecycle (rollout) gate — on/off switch controlling whether Post Office returns this message
export const ROVO_CHAT_NON_MAU_JIRA_CONFLUENCE_CTA_LIFECYCLE_GATE =
	'rovo_chat_non_mau_jira_confluence_cta_lifecycle';

// https://switcheroo.atlassian.com/ui/gates/1e0b68aa-bbf1-4e84-94fd-1bb0ca0b37e9/key/rovo_chat_non_mau_jira_confluence_cta
// Experiment gate — controls which copy variant (control/v1/v2/v3) the user sees
export const ROVO_CHAT_NON_MAU_JIRA_CONFLUENCE_CTA_EXPERIMENT =
	'rovo_chat_non_mau_jira_confluence_cta';

export const ROVO_CHAT_NON_MAU_JIRA_CONFLUENCE_CTA_TREATMENT_PARAM =
	'rovo_chat_non_mau_jira_confluence_cta_treatment';

export enum NonMauChatCtaCohort {
	CONTROL = 'control',
	V1 = 'v1',
	V2 = 'v2',
	V3 = 'v3',
}
